// extracted by mini-css-extract-plugin
module.exports = {"container":"WalletSelect_container_SXjOm","header":"WalletSelect_header_1MTs5","content":"WalletSelect_content_2K09G"};